var render = function (_h,_vm) {var _c=_vm._c;return _c('span',[(_vm.props.value)?_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.props.value))]})],2):_c('span',{staticClass:"empty"},[_vm._v("(空)")])])}
var staticRenderFns = []

export { render, staticRenderFns }